<template>
  <v-layout fill-height column class="page-solution-note">
    <div class="question">{{ ques[0] }}</div>
    <div class="answer">
      <div class="pb-8">
        <div class="d-flex">
          <v-btn-toggle
              v-model="toggle[0]"
              group
              mandatory
              class="btn-toggle mb-3"
          >
            <v-btn v-for="(item,index) in replyObjArr1" :key="index"
                   :class="{'active': userBtnReply[0].reply == item.reply}" v-text="item.replyCodeNm"
                   @click="setUserReply1(item)" :disabled="cmplt"></v-btn>
          </v-btn-toggle>
          <v-spacer/>
          <v-btn v-if="!cmplt && this.step > 1" small depressed plain outlined color="error" height="24"
                 class="my-1 rounded-pill" @click="btnDel(0)">
            <span class="fs-12">삭제</span>
          </v-btn>
        </div>
        <Textarea ref="textareaValue1"
                  :value="textarea[0]"
                  :height="140"
                  :counter="500"
                  :placeholder=placeholder[0].reply
                  @input="textareaVaule1"
                  :readonly="cmplt"
        />
      </div>
      <!-- 추가버튼 눌렸을 경우 -->
      <template v-if="step >= 2">
        <v-divider class="divider"></v-divider>
        <div class="pt-14 pb-8">
          <div class="d-flex">
            <v-btn-toggle
                v-model="toggle[1]"
                group
                mandatory
                class="btn-toggle mb-3"
            >
              <v-btn v-for="(item,index) in replyObjArr2" :key="index"
                     :class="{'active': userBtnReply[1].reply == item.reply}" v-text="item.replyCodeNm"
                     @click="setUserReply2(item)" :disabled="cmplt"></v-btn>
            </v-btn-toggle>
            <v-spacer/>
            <v-btn v-if="!cmplt && this.step > 1" small depressed plain outlined color="error" height="24"
                   class="my-1 rounded-pill" @click="btnDel(1)">
              <span class="fs-12">삭제</span>
            </v-btn>
          </div>
          <Textarea ref="textareaValue2"
                    :value="textarea[1]"
                    :height="140"
                    :counter="500"
                    :placeholder=placeholder[1].reply
                    @input="textareaVaule2"
                    :readonly="cmplt"
          />
        </div>
      </template>
      <!-- 추가버튼 눌렸을 경우 -->
      <template v-if="step >= 3">
        <v-divider class="divider"></v-divider>
        <div class="pt-14 pb-8">
          <div class="d-flex">
            <v-btn-toggle
                v-model="toggle[2]"
                group
                mandatory
                class="btn-toggle mb-3"
            >
              <v-btn v-for="(item,index) in replyObjArr3" :key="index"
                     :class="{'active': userBtnReply[2].reply == item.reply}" v-text="item.replyCodeNm"
                     @click="setUserReply3(item)" :disabled="cmplt"></v-btn>
            </v-btn-toggle>
            <v-spacer/>
            <v-btn v-if="!cmplt && this.step > 1" small depressed plain outlined color="error" height="24"
                   class="my-1 rounded-pill" @click="btnDel(2)">
              <span class="fs-12">삭제</span>
            </v-btn>
          </div>
          <Textarea ref="textareaValue3"
                    :value="textarea[2]"
                    :height="140"
                    :counter="500"
                    :placeholder=placeholder[2].reply
                    @input="textareaVaule3"
                    :readonly="cmplt"
          />
        </div>
      </template>
      <div v-if="!(step === 3) && !cmplt" class="text-center mt-n2 mb-8">
        <v-btn depressed plain class="btn-add" @click="btnAdd">+ 추가 작성하기</v-btn>
      </div>
<!--      <Modal :dialog="dialog" str="감사 유형버튼을 모두 선택해주세요." @close="modalClose"/>-->
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import Textarea from "@/components/forms/Textarea"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
// import Modal from "@/components/layout/modal/Modal";

import store from '@/store'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq", "regDt"],
  data: () => ({
    // dialog: false,
    step: 1,
    toggle: [null, null, null],
    disabledNext: true,
    textarea: ['', '', ''],
    free: 'N',
    cmplt: false,
    ques: [],
    //답변객체
    // replyArrTmp:[],
    replyObjArr1: [],
    replyObjArr2: [],
    replyObjArr3: [],
    placeholder: ['', '', ''],
    // 유저 답변 객체
    userReplyNo: [0, 0, 0, 0, 0, 0],
    userReply: [],
    userBtnReply: ['', '', ''],
    userBtnObj: [],
  }),
  components: {
    Textarea,
    FooterBtnsNext,
    // Modal
  },
  computed: {},
  watch: {},
  created() {
    this.getUnitDetailUse()
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = (this.cmpltYn === 'true' || this.cmpltYn === true) ? true : false

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [
              {'unitUseNo': this.unitUseNo},
              {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
              {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
              {'freeYn': 'Y'},
              {'regDt': this.regDt},
              {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)

              // 답변 셋팅
              this.placeholder.splice(0, this.placeholder.length);
              quesEl.unitDtlReplyList.forEach((replyEl, i) => {
                if (i < 4) {
                  this.replyObjArr1.push(replyEl)
                } else if (i > 4 && i < 9) {
                  this.replyObjArr2.push(replyEl)
                } else if (i > 9 && i < 14) {
                  this.replyObjArr3.push(replyEl)
                } else {
                  this.placeholder.push(replyEl)
                }
              });

              if (quesEl.memberUnitDtlReplyList.length > 0) {

                this.step = quesEl.memberUnitDtlReplyList.length / 2

                var j = 0
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl, i) => {
                  // this.userReply.push
                  if (i == 0) {
                    this.userBtnReply[0] = userReplyEl
                    this.userBtnObj.push(userReplyEl)
                  } else if (i == 2) {
                    this.userBtnReply[1] = userReplyEl
                    this.userBtnObj.push(userReplyEl)
                  } else if (i == 4) {
                    this.userBtnReply[2] = userReplyEl
                    this.userBtnObj.push(userReplyEl)
                  } else {
                    // this.placeholder[j] = userReplyEl
                    this.textarea[j] = userReplyEl.reply
                    j++
                  }
                  this.userReplyNo[i] = userReplyEl.memberUnitDtlReplyUseNo

                });

                if (this.textarea[0] != '') this.textareaVaule1(this.textarea[0])
                if (this.textarea[1] != '') this.textareaVaule2(this.textarea[1])
                if (this.textarea[2] != '') this.textareaVaule3(this.textarea[2])
              }
            });
          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 감사유형버튼 선택 여부 검사 및 답변 셋팅
        for (let i = 0; i < this.step; i++) {
          if (this.userBtnReply[i].reply == undefined || this.userBtnReply[i].reply == '') {
            this.$alert('감사 유형버튼을 모두 선택해주세요.')
            // this.dialog = true
            return
          }
        }

        this.placeholder.forEach((placEl, i) => {
          placEl.memberUnitDtlReplyUseNo = this.userReplyNo[(i * 2) + 1]
          placEl.userKey = this.$store.state.auth.authUser.userKey
          placEl.freeYn = this.free
          placEl.reply = this.textarea[i]
          placEl.unitType = "12"
        });

        for (let i = 0; i < this.userBtnReply.length; i++) {

          if (this.userReplyNo[(i * 2)] == 0 && this.userBtnReply[i] != '' && this.userBtnReply[i].reply != '') { //신규

            this.userBtnReply[i].memberUnitDtlReplyUseNo = this.userReplyNo[(i * 2)]
            this.userBtnReply[i].userKey = this.$store.state.auth.authUser.userKey
            this.userBtnReply[i].freeYn = this.free
            this.userBtnReply[i].unitType = "12"

            this.userReply.push(this.userBtnReply[i]) // 감사버튼 값
            this.userReply.push(this.placeholder[i])  // textarea 값

          } else if (this.userReplyNo[(i * 2)] > 0) {

            if (this.userBtnReply[i] == '') {
              this.userBtnReply[i] = {
                memberUnitDtlReplyUseNo: this.userReplyNo[(i * 2)],
                unitUseNo: this.userBtnObj[i].unitUseNo,
                unitNo: this.userBtnObj[i].unitNo,
                unitDtlUseNo: this.userBtnObj[i].unitDtlUseNo,
                unitDtlNo: this.userBtnObj[i].unitDtlNo,
                unitDtlQuesUseNo: this.userBtnObj[i].unitDtlQuesUseNo,
                unitDtlQuesNo: this.userBtnObj[i].unitDtlQuesNo,
                unitDtlReplyUseNo: this.userBtnObj[i].unitDtlReplyUseNo,
                unitDtlReplyNo: this.userBtnObj[i].unitDtlReplyNo,
                userKey: this.$store.state.auth.authUser.userKey,
                reply: '',
                freeYn: this.free,
                unitType: "12",
              }
            } else {
              this.userBtnReply[i].memberUnitDtlReplyUseNo = this.userReplyNo[(i * 2)]
              this.userBtnReply[i].userKey = this.$store.state.auth.authUser.userKey
              this.userBtnReply[i].freeYn = this.free
              this.userBtnReply[i].unitType = "12"
            }

            this.userReply.push(this.userBtnReply[i]) // 감사버튼 값
            this.userReply.push(this.placeholder[i])  // textarea 값
          }
        }
        this.disabledNext = true
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => {
                this.disabledNext = false
                this.$emit('next')
              }, 500); // 저장한 이후
            } else {
              this.disabledNext = false
              console.log(res.msg)
            }
          })
          .catch(error => {
            this.disabledNext = false
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    textareaVaule1(value) {
      this.textarea[0] = value;
      if (this.textarea[0] == "" || this.textarea[0].length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    textareaVaule2(value) {
      this.textarea[1] = value;
      if (this.textarea[0] == "" || this.textarea[0].length > 500 || this.textarea[1] == "" || this.textarea[1].length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    textareaVaule3(value) {
      this.textarea[2] = value;
      if (this.textarea[0] == "" || this.textarea[0].length > 500 || this.textarea[1] == "" || this.textarea[1].length > 500
        || this.textarea[2] == "" || this.textarea[2].length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    btnAdd() {
      this.step = this.step + 1;
      if (this.step == 2) this.textareaVaule2(this.textarea[1])
      if (this.step == 3) this.textareaVaule3(this.textarea[2])
      this.$nextTick(() => {
        let el = this.$refs[`textareaValue${this.step}`].$el
        el.querySelector('textarea').focus()
      })
    },
    btnDel(seq) {
      if (this.step > 1) {

        this.step = this.step - 1;

        this.textarea.splice(seq, 1)
        this.textarea.push('')
        this.userBtnReply.splice(seq, 1)
        this.userBtnReply.push('')

        if (this.step == 1) this.textareaVaule1(this.textarea[0])
        if (this.step == 2) this.textareaVaule2(this.textarea[1])
        if (this.step == 3) this.textareaVaule3(this.textarea[2])
      }
    },
    // modalClose() {
    //   this.dialog = false;
    // },
    setUserReply1(value) {
      this.userBtnReply.splice(0, 1, value)
    },
    setUserReply2(value) {
      this.userBtnReply.splice(1, 1, value)
    },
    setUserReply3(value) {
      this.userBtnReply.splice(2, 1, value)
    }
  }
}
</script>
<style lang="scss" scoped>
.v-btn-toggle--group.btn-toggle {
  margin-left: -4px;

  .v-btn {
    height: 24px !important;
    padding: 0 10px;
    background: #E9E6FF !important;
    font-size: 13px;
    color: var(--v-primary-base);
    border-radius: 20px !important;

    &.active {
      background: var(--v-primary-base) !important;
      color: #fff !important;
    }
  }
}
</style>
